import { SlipPrintDraft, SlipPrintJobModel } from "../models/SlipPrint.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Platform console: print "Visit Us" QR slips on a site's kitchen Pi without SSH (#1139). */
export class SlipPrintViewModel extends ViewModel {
    client;
    slug;
    constructor(client, slug) {
        super({ jobs: [], copiesText: "1", title: "", qrUrl: "", submitting: false, error: null });
        this.client = client;
        this.slug = slug;
    }
    /** Throws on failure so a LivePanel can surface it. */
    async load() {
        const rows = await this.client.listSlipPrintJobs(this.slug);
        this.setState({ jobs: rows.map((r) => new SlipPrintJobModel(r)) });
    }
    setCopies(copiesText) {
        this.setState({ copiesText });
    }
    setTitle(title) {
        this.setState({ title });
    }
    setQrUrl(qrUrl) {
        this.setState({ qrUrl });
    }
    async submit() {
        const draft = new SlipPrintDraft(this.state.copiesText, this.state.title, this.state.qrUrl);
        const errors = draft.validate();
        if (errors.length > 0) {
            this.setState({ error: errors.join(" ") });
            return;
        }
        await this.run(async () => {
            await this.client.createSlipPrintJob(this.slug, draft.toInput());
            await this.load();
        }, "Could not queue slips.", { flag: "submitting" });
    }
    async cancel(id) {
        await this.run(async () => {
            await this.client.cancelSlipPrintJob(this.slug, id);
            await this.load();
        }, "Could not cancel.", { flag: "submitting" });
    }
}
//# sourceMappingURL=SlipPrintViewModel.js.map